import RadioInput from '../../../Shared/RadioInput/RadioInput';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { setServiceForm, setShowPopUp } from './../TransferOrganizationAccountSlice';
import { ServiceData } from '../Constant/ServiceFormText';

const ServiceFormPopup = (props) => {
  const [openServices, setOpenServices] = useState([]);

  useEffect(() => {
    var openServices = Object.keys(props.data.serviceForm).filter((key) => props.data.serviceForm[key]);
    setOpenServices([...openServices]);
  }, []);

  const closeServicePopup = () => {
    props.setServiceForm(openServices);
    props.setShowPopUp(false);
  };

  const RadioBtnService = ({ service }) => {
    return (
      <div className='radio-btn'>
        <RadioInput
          id={'close' + service.type}
          name={'ServiceForm' + service.type}
          checked={!openServices.includes(service.type)}
          onChange={() => {
            setOpenServices(openServices.filter((s) => s !== service.type));
          }}
        />
        <RadioInput
          id={'open' + service.type}
          name={'ServiceForm' + service.type}
          checked={openServices.includes(service.type)}
          onChange={() => {
            setOpenServices([...openServices, service.type]);
          }}
        />
      </div>
    );
  };

  return (
    <div className='servicesForm'>
      <div className='L_Title'> טופס גישה לשירותים </div>

      <div className='wrap-section'>
        {ServiceData.map((item, SectionId) => {
          return (
            <div className='section' key={SectionId}>
              <div className='section-title'>
                {item.title && (
                  <p className='mainTitle'>
                    {SectionId + 1}. {item.title}
                  </p>
                )}
                {SectionId == 0 ? (
                  <div className='openCloseTitle'>
                    <p>חסום</p>
                    <p>פתוח</p>
                  </div>
                ) : (
                  <div className='withoutServiceText'>{!item.services[0].value && <RadioBtnService service={item.services[0]} />}</div>
                )}
              </div>

              <ol>
                {item.services[0].value &&
                  item.services.map((service, ServiceId) => {
                    return (
                      <>
                        {!service.type ?
                          <p className='service-text'>{service.value}</p>
                          :
                          <li className='service hebrew_li' key={ServiceId}>
                            <p className='service-text'>{service.value}</p>
                            <div className='radio-btn'>
                              <RadioBtnService service={service} />
                            </div>
                          </li>
                        }
                      </>
                    );
                  })}
              </ol>
            </div>
          );
        })}
      </div>
      <BtnSubmit text={'אישור וחזרה לתהליך'} onclick={() => closeServicePopup()} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
});

const mapDispatchToProps = {
  setServiceForm,
  setShowPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceFormPopup);
